import React from 'react';
import Moment from 'react-moment';
import { User } from '@vidende/contracts';
import { useGetFeatures } from './utils/Features';

import './FormFieldAuthor.scss';

type FieldAuthorProps = {
    user: Pick<User, 'firstName' | 'lastName'>;
    // Accepts a wire date string (contract dates are string-truthful) or a Date;
    // react-moment's <Moment date> parses both.
    modifiedDate: string | Date;
    dateFormat?: string;
};

export const FieldAuthor = ({
    user,
    modifiedDate,
    dateFormat,
}: FieldAuthorProps) => {
    const { HideAuthor } = useGetFeatures();
    // Cast: the `&&` short-circuit can yield `false`, which React renders as
    // nothing but @types/react rejects as a component return type.
    return (!HideAuthor && (
        <div className="form-field-author">
            {user.firstName} {user.lastName} -{' '}
            <Moment date={modifiedDate} format={dateFormat} />
        </div>
    )) as JSX.Element;
};
